var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-5"},[_c('account-detail'),_c('org-notification-from-email'),_c('org-notification-emails'),(_vm.showSubAccounts)?_c('sub-account'):_vm._e()],1),_c('div',{staticClass:"col-12 col-lg-7"},[_c('account-settings')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }